import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6163c4d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-tel-input__label"
}
const _hoisted_2 = {
  key: 1,
  class: "app-tel-input__error"
}

import 'vue-tel-input/vue-tel-input.css'

import { VueTelInput } from 'vue-tel-input'

interface Props {
  label?: string
  wrapperClasses?: string
  isError?: boolean
  errorText?: string
  tabindex?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppPhoneInput',
  props: {
    label: {},
    wrapperClasses: {},
    isError: { type: Boolean },
    errorText: {},
    tabindex: {}
  },
  setup(__props: any) {

const props = __props;



const inputOptions = {
  placeholder: '',
  tabindex: props.tabindex,
  autocomplete: 'tel',
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-tel-input", _ctx.wrapperClasses])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_unref(VueTelInput), _mergeProps(_ctx.$attrs, {
      "style-classes": [
        'app-tel-input__field',
        { 'app-tel-input__field_invalid': _ctx.isError },
      ],
      "valid-characters-only": "",
      "invalid-msg": _ctx.errorText,
      "input-options": inputOptions
    }), null, 16, ["style-classes", "invalid-msg"]),
    (_ctx.isError && _ctx.errorText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.errorText), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})